import produce from 'immer';

const INITIAL_STATE = {
  data: null,
};

export default function turmas(state = INITIAL_STATE, action) {
  return produce(state, (draft) => {
    switch (action.type) {
      case '@turmas/REQUEST_SUCCESS': {
        draft.data = action.payload.turmas;
        break;
      }
      case '@auth/SIGN_OUT': {
        draft.data = null;
        break;
      }
      default:
    }
  });
}
